/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const VerticalAlignMiddleIcon = /*#__PURE__*/ createSvgIcon(
  'VerticalAlignMiddleIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.25 14.875l-.667.667a.73.73 0 01-1.062 0 .73.73 0 010-1.063l1.955-1.95a.724.724 0 01.527-.216c.1 0 .194.017.282.052a.69.69 0 01.236.156l1.958 1.958c.153.153.23.327.23.521a.718.718 0 01-.23.52.73.73 0 01-1.062 0l-.667-.645v2.708c0 .213-.072.391-.214.535a.719.719 0 01-.532.215.734.734 0 01-.535-.215.72.72 0 01-.219-.535v-2.708zM4.756 11a.738.738 0 01-.537-.214.714.714 0 01-.219-.532c0-.21.072-.39.215-.535A.72.72 0 014.75 9.5h10.494c.212 0 .391.071.537.214.146.143.219.32.219.532 0 .21-.072.39-.215.535a.72.72 0 01-.535.219H4.756zM9.25 5.125V2.744c0-.21.071-.387.214-.53A.722.722 0 019.996 2c.21 0 .39.071.535.214.146.143.219.32.219.53v2.381l.667-.667a.729.729 0 011.062 0 .73.73 0 010 1.063l-1.955 1.95a.724.724 0 01-.527.216.76.76 0 01-.282-.052.69.69 0 01-.236-.156L7.521 5.521a.693.693 0 01-.219-.531.769.769 0 01.24-.532.73.73 0 011.062 0l.646.667z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default VerticalAlignMiddleIcon;
